export default __webpack_public_path__ + "images/family_icon_left-dc7cd2926ef7a9ef47dac15c84912eac.svg";